import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1509bbf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Word export", -1))
const _hoisted_2 = { class: "img-container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "svg" }, "SVG", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "png" }, "PNG", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import MicrogestureInput from '@/components/Microgesture/MicrogestureInput'
import { inject, reactive, ref } from 'vue'
import ButtonComponent from '@/components/UI/ButtonComponent.vue'


export default {
  __name: 'WordExportView',
  setup(__props) {

const axios = inject('axios')

const microgesture = ref(undefined)
const type = ref('png')
const svg = ref('')
const refreshed = reactive({
  svg: 0,
  png: 0
})

function download () {
  if (type.value === 'svg') {
    const preface = '<?xml version="1.0" standalone="no"?>\r\n'
    const svgBlob = new Blob([preface, svg.value], { type: 'image/svg+xml;charset=utf-8' })
    const svgUrl = URL.createObjectURL(svgBlob)
    const downloadLink = document.createElement('a')
    downloadLink.href = svgUrl
    downloadLink.download = 'mglyph.svg'
    downloadLink.click()
  } else {
    downloadPNG()
  }
}

function downloadPNG () {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const DOMURL = window.URL || window.webkitURL || window

  const img = new Image()
  const svgBlob = new Blob([svg.value], { type: 'image/svg+xml;charset=utf-8' })
  const url = DOMURL.createObjectURL(svgBlob)

  img.onload = function () {
    ctx?.drawImage(img, 0, 0)
    DOMURL.revokeObjectURL(url)

    const imgURI = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream')

    const downloadLink = document.createElement('a')
    downloadLink.href = imgURI
    downloadLink.download = 'mglyph.png'
    downloadLink.click()

    ctx?.clearRect(0, -50, canvas.width, canvas.height)
  }

  img.src = url
}

function updateMicrogesture (newMicrogesture) {
  microgesture.value = newMicrogesture
}

function getImage () {
  axios.get(`/api/microgesture/svg/${JSON.stringify(microgesture.value)}`)
    .then((d) => {
      svg.value = d.data
      refreshed[type.value]++
    })
}


return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createTextVNode(" To export to word, we propose to export the µGlyph description to a svg/png file. "),
    _createVNode(_unref(MicrogestureInput), {
      "model-value": microgesture.value,
      "onUpdate:modelValue": updateMicrogesture,
      "allow-edit-button": false
    }, null, 8, ["model-value"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", { innerHTML: svg.value }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createTextVNode(" File type: "),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((type).value = $event))
        }, _hoisted_6, 512), [
          [_vModelSelect, type.value]
        ])
      ]),
      _createVNode(ButtonComponent, { onClick: getImage }, {
        default: _withCtx(() => [
          _createTextVNode("Refresh image")
        ]),
        _: 1
      }),
      (refreshed[type.value])
        ? (_openBlock(), _createBlock(ButtonComponent, {
            key: 0,
            onClick: download
          }, {
            default: _withCtx(() => [
              _createTextVNode("Download")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}